var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2096 3.28125H7.65755C7.27078 3.28125 6.89985 3.4349 6.62635 3.70839C6.35286 3.98188 6.19922 4.35281 6.19922 4.73958V30.2604C6.19922 30.6472 6.35286 31.0181 6.62635 31.2916C6.89985 31.5651 7.27078 31.7188 7.65755 31.7188H27.3451C27.7318 31.7188 28.1028 31.5651 28.3762 31.2916C28.6497 31.0181 28.8034 30.6472 28.8034 30.2604V4.73958C28.8034 4.35281 28.6497 3.98188 28.3762 3.70839C28.1028 3.4349 27.7318 3.28125 27.3451 3.28125H17.5013",
    stroke: "#FF0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.75 3.28133L9.78104 2.25029C10.0545 1.97678 10.4253 1.82308 10.8121 1.823H16.7708C16.9642 1.823 17.1497 1.89982 17.2864 2.03657C17.4232 2.17331 17.5 2.35878 17.5 2.55216V20.7813L13.8542 17.1355L10.2083 20.7813V3.28133M10.2083 27.7084H24.7917M17.5 7.29175H24.7917M17.5 12.3959H24.7917M17.5 17.5001H24.7917M10.2083 22.6042H24.7917",
    stroke: "#FF0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentRed);
export default __webpack_public_path__ + "static/media/document_red.32a825632c0b3de542d323a16276b075.svg";
export { ForwardRef as ReactComponent };